import tokens from '../tokens/js/tokens';
import active from './palette.schema.active';
import brand1 from './palette.schema.brand1';
import brand2 from './palette.schema.brand2';
import info from './palette.schema.info';
import negative from './palette.schema.negative';
import neutral from './palette.schema.neutral';
import notice from './palette.schema.notice';
import positive from './palette.schema.positive';
// Default palette.
// -----------------------------------------------------------------------------
export const palette = {
    // Colors
    schema: {
        active,
        brand1,
        brand2,
        info,
        negative,
        neutral,
        notice,
        positive
    },
    // Text
    text: {
        primary: tokens.colors.midnight[800].value,
        secondary: tokens.colors.midnight[800].value,
        disabled: tokens.colors.midnight[800].value,
        subtle: tokens.colors.midnight[500].value
    }
};
//# sourceMappingURL=palette.js.map